import {HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {LoaderService} from "../../services/loader/loader.service";
import {inject} from "@angular/core";
import {finalize} from "rxjs";

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {

  const loaderService = inject(LoaderService);

  loaderService.setLoading(true);

  return next(req).pipe(
    finalize(() => {
      loaderService.setLoading(false); // Hide spinner
    })
  );
};
